{
  "layout": {
    "tagline": "Todo lo que necesitas para lanzar, en un solo lugar.",
    "subtitle": "Inicia sesión para gestionar tu espacio de trabajo, tu equipo y tus datos."
  },
  "login": {
    "title": "Iniciar sesión",
    "description": "Inicia sesión en tu cuenta para continuar.",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "rememberMe": "Recordarme",
    "submit": "Iniciar sesión",
    "submitting": "Iniciando sesión...",
    "forgotPassword": "¿Olvidaste tu contraseña?",
    "magicLink": "Iniciar sesión con enlace mágico",
    "or": "o",
    "magicLinkSent": "¡Enlace mágico enviado! Revisa tu correo.",
    "magicLinkError": "No se pudo enviar el enlace mágico. Inténtalo de nuevo.",
    "noAccount": "¿No tienes una cuenta?",
    "register": "Regístrate",
    "success": "¡Bienvenido de nuevo!",
    "error": "Correo o contraseña incorrectos. Inténtalo de nuevo.",
    "accountLocked": "Tu cuenta se ha bloqueado por demasiados intentos fallidos. Revisa tu correo para desbloquearla.",
    "emailNotVerified": "Verifica tu correo antes de iniciar sesión. Revisa tu bandeja de entrada para encontrar el enlace de verificación."
  },
  "register": {
    "title": "Registrarse",
    "description": "Crea una cuenta nueva para empezar.",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "email": "Correo electrónico",
    "password": "Contraseña",
    "confirmPassword": "Confirmar contraseña",
    "acceptTerms": "Acepto los términos y condiciones",
    "submit": "Crear cuenta",
    "submitting": "Creando cuenta...",
    "hasAccount": "¿Ya tienes una cuenta?",
    "login": "Iniciar sesión",
    "success": "¡Cuenta creada correctamente!",
    "successDescription": "Hemos enviado un correo de verificación a tu bandeja de entrada. Revísalo para verificar tu cuenta.",
    "error": "Error al registrarse. Inténtalo de nuevo.",
    "passwordStrength": {
      "label": "Seguridad de la contraseña",
      "weak": "Débil",
      "fair": "Aceptable",
      "strong": "Fuerte"
    }
  },
  "signup": {
    "title": "Crea tu cuenta",
    "description": "Configura tu cuenta y tu organización en unos pocos pasos.",
    "stepper": {
      "account": "1 Cuenta",
      "organization": "2 Organización",
      "review": "3 Revisión",
      "compact": "Paso {{current}} de {{total}}",
      "progress": "Progreso del registro"
    },
    "step1": {
      "email": "Correo electrónico",
      "firstName": "Nombre",
      "lastName": "Apellidos",
      "password": "Contraseña",
      "confirmPassword": "Confirmar contraseña"
    },
    "step2": {
      "orgName": "Nombre de la organización",
      "subdomain": "Subdominio"
    },
    "step3": {
      "heading": "Revisa tus datos",
      "email": "Correo electrónico",
      "name": "Nombre",
      "orgName": "Organización",
      "subdomain": "Dirección",
      "acceptTerms": "Acepto los términos y condiciones"
    },
    "availability": {
      "checking": "Comprobando disponibilidad…"
    },
    "email": {
      "taken": "Ese correo ya está registrado. Prueba a iniciar sesión."
    },
    "subdomain": {
      "preview": "{{slug}}.myproduct.com",
      "available": "{{slug}}.myproduct.com está disponible",
      "taken": "Esa dirección ya está ocupada. Prueba con otra."
    },
    "passwordStrength": {
      "label": "Seguridad de la contraseña",
      "weak": "Débil",
      "fair": "Aceptable",
      "strong": "Fuerte"
    },
    "continue": "Continuar",
    "back": "Atrás",
    "submit": "Crear cuenta",
    "submitting": "Creando cuenta...",
    "success": "¡Cuenta creada correctamente!",
    "error": "Algo salió mal al crear tu cuenta. Inténtalo de nuevo.",
    "hasAccount": "¿Ya tienes una cuenta?",
    "login": "Iniciar sesión"
  },
  "invite": {
    "heading": "Te estás uniendo a {{tenantName}}",
    "loading": "Comprobando tu invitación…",
    "email": "Correo electrónico",
    "emailHelper": "Esta es la dirección con la que te invitaron.",
    "firstName": "Nombre",
    "lastName": "Apellidos",
    "password": "Contraseña",
    "acceptTerms": "Acepto los términos y condiciones",
    "submit": "Aceptar invitación",
    "submitting": "Aceptando...",
    "success": "¡Invitación aceptada! Ya puedes iniciar sesión.",
    "error": "Algo salió mal al aceptar tu invitación. Inténtalo de nuevo.",
    "invalidHeading": "Esta invitación no es válida",
    "invalidBody": "Es posible que haya caducado o que ya se haya utilizado. Pide a tu administrador que te envíe una nueva.",
    "goToSignIn": "Ir a iniciar sesión",
    "passwordStrength": {
      "label": "Seguridad de la contraseña",
      "weak": "Débil",
      "fair": "Aceptable",
      "strong": "Fuerte"
    }
  },
  "welcome": {
    "heading": "¡Te damos la bienvenida a {{orgName}}!",
    "headingGeneric": "¡Te damos la bienvenida!",
    "body": "Tu espacio de trabajo está listo. Invita a tu equipo o empieza directamente.",
    "goToDashboard": "Ir al panel",
    "inviteTeam": "Invita a tu equipo"
  },
  "twoFactor": {
    "title": "Autenticación en dos pasos",
    "description": "Introduce el código de 6 dígitos de tu app de autenticación.",
    "codeLabel": "Código de verificación",
    "submit": "Verificar",
    "submitting": "Verificando...",
    "useBackupCode": "Usar un código de respaldo",
    "useAuthenticator": "Usar la app de autenticación",
    "useEmailCode": "Usar un código por correo",
    "emailCodeSent": "Se ha enviado un código de verificación a tu correo.",
    "emailCodeError": "No se pudo enviar el código por correo. Inténtalo de nuevo.",
    "emailCodeLabel": "Código de verificación por correo",
    "emailCodeDescription": "Introduce el código de 6 dígitos enviado a tu correo.",
    "backupCodeLabel": "Código de respaldo",
    "backupCodeDescription": "Introduce uno de tus códigos de respaldo.",
    "success": "¡Verificación correcta!",
    "error": "Código de verificación incorrecto. Inténtalo de nuevo.",
    "backupError": "Código de respaldo incorrecto. Inténtalo de nuevo.",
    "emailOtpError": "Código de verificación por correo incorrecto. Inténtalo de nuevo.",
    "backToLogin": "Volver a iniciar sesión"
  },
  "forgotPassword": {
    "title": "Olvidé mi contraseña",
    "description": "Introduce tu correo para restablecer tu contraseña.",
    "email": "Correo electrónico",
    "submit": "Enviar enlace de restablecimiento",
    "submitting": "Enviando...",
    "success": "¡Enlace de restablecimiento enviado!",
    "successDescription": "Si existe una cuenta con ese correo, recibirás en breve un enlace para restablecer la contraseña.",
    "backToLogin": "Volver a iniciar sesión",
    "error": "No se pudo enviar el enlace de restablecimiento. Inténtalo de nuevo."
  },
  "resetPassword": {
    "title": "Restablecer contraseña",
    "description": "Introduce una nueva contraseña para tu cuenta.",
    "password": "Nueva contraseña",
    "confirmPassword": "Confirmar nueva contraseña",
    "submit": "Restablecer contraseña",
    "submitting": "Restableciendo...",
    "success": "¡Contraseña restablecida correctamente!",
    "successDescription": "Has iniciado sesión automáticamente.",
    "backToLogin": "Volver a iniciar sesión",
    "error": "No se pudo restablecer la contraseña. Inténtalo de nuevo.",
    "invalidToken": "Este enlace de restablecimiento no es válido o ha caducado.",
    "twoFactorCode": "Código de doble factor",
    "twoFactorHint": "Introduce el código de 6 dígitos de tu aplicación de autenticación para terminar de restablecer tu contraseña."
  },
  "checkEmail": {
    "title": "Revisa tu correo",
    "description": "Hemos enviado un correo de verificación a tu bandeja de entrada.",
    "instructions": "Haz clic en el enlace de verificación del correo para activar tu cuenta.",
    "backToLogin": "Volver a iniciar sesión"
  },
  "verifyEmail": {
    "verifying": "Verificando tu correo…",
    "successHeading": "Correo verificado",
    "successBody": "Tu dirección de correo se ha verificado.",
    "errorHeading": "Este enlace de verificación no es válido",
    "errorBody": "Es posible que haya caducado o que ya se haya utilizado. Inicia sesión para solicitar uno nuevo.",
    "goToSignIn": "Ir a iniciar sesión",
    "continueToWelcome": "Continuar"
  }
}
